import React from "react";
import { StyledDiv } from "./layoutWr.styles";

const LayoutWr = ({ children }) => {
  return <StyledDiv>{children}</StyledDiv>;
};

export default LayoutWr;
